import React from 'react';
import { Doughnut, Line, Bar, Pie } from 'react-chartjs-2';

function ReportChart({ type = 'bar', data, options = {}, title, height = 300 }) {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom'
      },
      title: {
        display: !!title,
        text: title
      }
    },
    scales: {
      x: {
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          autoSkip: false,
          font: {
            size: 11
          }
        }
      },
      y: {
        beginAtZero: true
      }
    },
    ...options
  };

  const renderChart = () => {
    switch (type) {
      case 'doughnut':
        return <Doughnut data={data} options={defaultOptions} />;
      case 'line':
        return <Line data={data} options={defaultOptions} />;
      case 'bar':
        return <Bar data={data} options={defaultOptions} />;
      case 'pie':
        return <Pie data={data} options={defaultOptions} />;
      default:
        return <Bar data={data} options={defaultOptions} />;
    }
  };

  return (
    <div className="card h-100">
      <div className="card-body">
        {title && !options.plugins?.title?.display && (
          <h5 className="card-title mb-3">{title}</h5>
        )}
        <div style={{ height: `${height}px` }}>
          {renderChart()}
        </div>
      </div>
    </div>
  );
}

export default ReportChart;
